import React, { ComponentProps } from "react";
import { IonContent, IonFooter, IonHeader, IonPage } from "@ionic/react";
import ToolbarDesktop, { IToolbarDesktop } from "../../components/Toolbar/ToolbarDesktop/ToolbarDesktop";
import ToolbarMobile, { IToolbarMobileProps } from "../../components/Toolbar/ToolbarMobile/ToolbarMobile";
import Footer from "../../components/Footer/Footer";
import useWindowSize from "../../utils/useWindowSize";
import { getChildrenOnDisplayName } from "../../utils/getChildrenOnDisplayName";

type PageProps = ComponentProps<typeof IonContent>;

type HeaderProps = ComponentProps<typeof IonHeader>;

type ContentProps = ComponentProps<typeof IonContent>;

type HeaderMobileProps = IToolbarMobileProps;

type HeaderDesktopProps = IToolbarDesktop;

type PageFooterProps = ComponentProps<typeof IonFooter>;

const Page = ({ children, ...props }: PageProps) => {
  const header = getChildrenOnDisplayName(children, "Header");

  const headerMobile = getChildrenOnDisplayName(children, "HeaderMobile");

  const headerDesktop = getChildrenOnDisplayName(children, "HeaderDesktop");

  const content = getChildrenOnDisplayName(children, "Content");

  const contentFooter = getChildrenOnDisplayName(children, "ContentFooter");

  const pageFooter = getChildrenOnDisplayName(children, "PageFooter");

  return (
    <IonPage {...props}>
      {header}
      {headerMobile?.length > 0 ? <Header>{headerMobile}</Header> : null}
      {headerDesktop}
      {content}
      {contentFooter}
      {pageFooter}
    </IonPage>
  );
};

const Header = ({ children, ...props }: HeaderProps) => {
  return <IonHeader {...props}>{children}</IonHeader>;
};

Page.Header = Header;
Header.displayName = "Header";

const HeaderMobile = ({ ...props }: HeaderMobileProps) => {
  const { width, md } = useWindowSize();

  return width < md ? <ToolbarMobile {...props} /> : null;
};

Page.HeaderMobile = HeaderMobile;
HeaderMobile.displayName = "HeaderMobile";

const HeaderDesktop = ({ ...props }: HeaderDesktopProps) => {
  const { width, md } = useWindowSize();

  return width >= md ? <ToolbarDesktop {...props} /> : null;
};

Page.HeaderDesktop = HeaderDesktop;
HeaderDesktop.displayName = "HeaderDesktop";

const Content = React.forwardRef<HTMLIonContentElement, ContentProps>(({ children, ...props }, ref) => {
  return <IonContent ref={ref} {...props}>{children}</IonContent>;
});

Page.Content = Content;
Content.displayName = "Content";

const ContentFooter = () => {
  return <Footer />;
};

Page.ContentFooter = ContentFooter;
ContentFooter.displayName = "ContentFooter";

const PageFooter = ({ children, ...props }: PageFooterProps) => {
  return <IonFooter {...props}>{children}</IonFooter>;
};

Page.PageFooter = PageFooter;
PageFooter.displayName = "PageFooter";

export default Page;
